module.exports = __webpack_public_path__ + "static/media/face5a.2039e4ba.jpg";